import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link } from "react-router-dom";

/**
 * Confirmation screen for both password flows, reached from Register (words="crear") and
 * RecuperarContraseña (words="recuperar").
 *
 * Both copies are deliberately conditional: "si la cuenta existe", not "te enviamos". Both
 * screens call the same recoverPassword endpoint, which answers 200 for every cuenta contrato
 * so that nobody can tell a real customer from a stranger. That means this screen is shown to
 * people whose account does not exist, or exists with no email on file, and stating that a mail
 * was sent would be telling them something false while they wait for it.
 *
 * Do not reword these back into a flat promise. The vague phrasing is the cost of not leaking
 * the customer list, and it is the cheaper of the two.
 */
const MailEnviado = (props) => {
  const words = props.words;

  return (
    <div>
      <div>
        <Container maxWidth="sm">
          <br />
          <Link to="/" style={{ textDecoration: "none", alignSelf: "center" }}>
            <Button
              startIcon={<ArrowBackIosIcon />}
              style={{
                marginLeft: "0%",
                width: "8%",
                textTransform: "none",
                backgroundColor: "white",
                color: "blue",
              }}
            >
              Volver
            </Button>
          </Link>

          {words == "recuperar" && (
            <div>
              <h1>Recupero de contraseña</h1>
              <p>
                Si la cuenta existe y tiene un e-mail asociado, vas a recibir un
                e-mail para completar la renovación de tu contraseña.
              </p>
            </div>
          )}
          {words == "crear" && (
            <div>
              <h1>Creación de contraseña</h1>
              <p>
                Si la cuenta existe y tiene un e-mail asociado, vas a recibir un
                e-mail para completar la creación de tu contraseña.
              </p>
            </div>
          )}
        </Container>
      </div>
    </div>
  );
};
export default MailEnviado;
